<template>
    <!-- 订单管理-积分订单管理-实物订单详情 -->
    <content-view>
        <template slot="header">
            <div class="pt24 pb24">
                <span style="cursor: pointer;" @click="$router.back();"><a-icon class="mr8" type="left" />返回订单列表</span>
            </div>
        </template>
        <div class="retail-order-detail wrap-container-in">
            <a-spin :spinning="spinning">
                <div class="font-weight font-big">用户信息</div>
                <a-row class="mt24">
                    <a-col :span="6">会员昵称：{{orderDetail.account}}</a-col>
                    <a-col :span="6">会员手机号：{{orderDetail.phone}}</a-col>
                </a-row>
                <a-divider></a-divider>
                <div class="font-weight font-big">交易信息</div>
                <a-row class="mt24">
                    <a-col :span="7">交易订单号：{{orderDetail.transNo}}</a-col>
                    <a-col :span="7">下单时间：{{orderDetail.orderTime}}</a-col>
                    <a-col :span="7">支付时间：{{orderDetail.payTime | isEmpty}}</a-col>
                </a-row>
                <a-row class="mt24">
                    <a-col :span="7">交易状态：{{orderDetail.transStateStr}}</a-col>
                    <a-col :span="7">应收积分：{{orderDetail.orderPoint | thousandFormat}}</a-col>
                    <a-col :span="7">实收积分：{{orderDetail.payPoint | thousandFormat}}</a-col>
                </a-row>
                <a-divider></a-divider>
                <div class="font-weight font-big">物流信息</div>
                <a-row class="mt24">
                    <a-col :span="7">预约提货日期：{{logistics.appointDeliveryDate | isEmpty}}</a-col>
                    <a-col :span="7">提货时间：{{logistics.deliveryDate | isEmpty}}</a-col>
                    <a-col :span="7">自提门店：{{logistics.shopName | isEmpty}}</a-col>
                </a-row>
                <a-divider></a-divider>
                <div class="font-weight font-big mb24">实物信息</div>
                <a-table bordered :dataSource="orderDetail.orderGoods" :columns="columns" :pagination="false" :rowKey="(record, index) => index">
                    <template slot="isEmpty" slot-scope="key, row, index">{{key | isEmpty}}</template>
                    </a-table>
            </a-spin>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    const columns = [
        {
            title: "商城展示名称",
            dataIndex: "showName"
        },
        {
            title: "物料名称",
            dataIndex: "goodsName"
        },
        {
            title: "物料编码",
            dataIndex: "materialNo"
        },
        {
            title: "实收积分",
            dataIndex: "point",
            scopedSlots: { customRender: "thousandFormat" }
        },
        {
            title: "提货码",
            dataIndex: "deliveryNo",
            scopedSlots: { customRender: "isEmpty" }
        }
    ];
    export default {
        name: "pointOrderDetailRetail",
        components: {
        },
        props: {},
        data() {
            return {
                columns,
                orderDetail: {
                    orderGoods: []
                },
                spinning: true,
                logistics: {}
            };
        },

        computed: {
        },
        methods: {
            /**
             * @func getDetial 获取订单详情
             */
            getDetial() {
                let transNo = this.$route.params.tradeNo;
                if (!Boolean(transNo)) {
                    this.$router.back();
                    return false;
                }
                this.$api.order.viewTrade({
                    body: {
                        transNo,
                        source: 'RETAIL',
                        transStateStr: this.$route.query.transStateStr || null
                    }
                }).then(res => {
                    this.spinning = false;
                    if (!Boolean(res.orderGoods)) {
                        res.orderGoods = [];
                    }
                    if (Boolean(res.logisticsVo)) {
                        this.logistics = res.logisticsVo;
                    }
                    this.orderDetail = res;
                })
            }
        },
        created() {},
        mounted() {
            this.getDetial();
        },
        watch: {
        },
        beforeCreate() {
        }
    };
</script>

<style lang="scss">

</style>
